import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M3.5 8.5C3.22386 8.5 3 8.27614 3 8C3 5.29191 5.11617 3.10935 7.79688 3.00399L7.14645 2.35355C6.95118 2.15829 6.95118 1.84171 7.14645 1.64645C7.34171 1.45118 7.65829 1.45118 7.85355 1.64645L9.28284 3.07574C9.51716 3.31005 9.51716 3.68995 9.28284 3.92426L7.85355 5.35355C7.65829 5.54882 7.34171 5.54882 7.14645 5.35355C6.95118 5.15829 6.95118 4.84171 7.14645 4.64645L7.78745 4.00544C5.66404 4.11439 4 5.84747 4 8C4 8.27614 3.77614 8.5 3.5 8.5ZM12.4999 7.5C12.7761 7.5 12.9999 7.72386 12.9999 8C12.9999 10.7081 10.8837 12.8906 8.20304 12.996L8.85347 13.6464C9.04874 13.8417 9.04874 14.1583 8.85347 14.3536C8.65821 14.5488 8.34163 14.5488 8.14637 14.3536L6.71708 12.9243C6.48276 12.69 6.48276 12.3101 6.71708 12.0757L8.14637 10.6464C8.34163 10.4512 8.65821 10.4512 8.85347 10.6464C9.04874 10.8417 9.04874 11.1583 8.85347 11.3536L8.21246 11.9946C10.3359 11.8856 11.9999 10.1525 11.9999 8C11.9999 7.72386 12.2238 7.5 12.4999 7.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
